import {
    TRANSACTIONS_RESULT_REQUEST,
    TRANSACTIONS_RESULT_RESULT,
} from 'Redux/actionTypes';

export const transactionsResultRequest = (filters) => ({
    type: TRANSACTIONS_RESULT_REQUEST,
    payload: filters,
})

export const transactionsResultResult = (result) => ({
    type: TRANSACTIONS_RESULT_RESULT,
    payload: result,
})